import React, { createContext, useContext, useState, ReactNode } from 'react';

interface GalleryReloadContextType {
  reloadTrigger: number;
  triggerReload: () => void;
}

const GalleryReloadContext = createContext<GalleryReloadContextType | undefined>(undefined);

export const useGalleryReload = (): GalleryReloadContextType => {
  const context = useContext(GalleryReloadContext);
  if (!context) {
    throw new Error('useGalleryReload must be used within a GalleryReloadProvider');
  }
  return context;
};

interface GalleryReloadProviderProps {
  children: ReactNode;
}

export const GalleryReloadProvider: React.FC<GalleryReloadProviderProps> = ({ children }) => {
  const [reloadTrigger, setReloadTrigger] = useState<number>(0);

  const triggerReload = () => {
    setReloadTrigger(prev => prev + 1);
  };

  return (
    <GalleryReloadContext.Provider value={{
      reloadTrigger,
      triggerReload
    }}>
      {children}
    </GalleryReloadContext.Provider>
  );
};